import React, { Component } from 'react';
import { Header } from 'formlabs-web-components/Type';

class HeaderPlugin extends Component {
  render() {
    const { text, ...props } = this.props;
    return <Header {...props}>{text}</Header>;
  }
}

export default HeaderPlugin;
